<template>
  <div v-if="agreeShow && isShow">
    <div class="checkout_wrap">
      <el-checkbox v-model="checked" @change="checkboxEvt()"></el-checkbox>
      我已阅读并同意<el-link type="danger" :underline="false" @click="show = true" style="font-size:14px;">《{{agreementName}}》</el-link>
    </div>
    <el-dialog :width="agreementDetail.length > 1000 ? '800px': ''" :top="agreementDetail.length > 1000 ? '15vh': '30vh'" :title="agreementName" :visible.sync="show"
      append-to-body :before-close="close" :close-on-click-modal="false" 
      :class="['dialog', {'agreementName-show': !agreementName}]" >
      <el-row style="text-align:left;">
        <img v-show='url' :src="url" />
        <div v-html="agreementDetail"  :class="{'contentWrap':agreementDetail.length > 1000 }"></div>
        <div class="btnDia">
          <el-button @click="close">关闭</el-button>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "agreeDialog",
  props: {
    agreeShow: {type: Boolean, default: true },
    img: { type: String, default: "" },
    areaConfigId: { type: String, default: "" },
    content: { type: String, default: "。。" },
    width: { type: String, default: '340px' },
    top: { type: String, default: '30vh' },
  },
  data() {
    return {
      show: false,
      checked: false,
      agreementName: "", //协议名称
      agreementDetail: "",  //协议详情
      isShow: 0,  //是否展示 0 否 1是
    }
  },
  computed: {
    url() {
      if(this.img){
        return require("../../assets/" + this.img)
      }
    }
  },
  created () {
    if(this.agreeShow){
      this.getRule()
    }
  },
  methods: {
    checkboxEvt(){
      this.$emit('checkAgree',this.checked)
    },
    async getRule(areaConfigId = "") {
      let params = {
        areaConfigId: this.$store.state.cityArea.areaConfigId
      }
      if (areaConfigId) params.areaConfigId = areaConfigId
      await this.$api.my.getAgreement(params).then((res) => {
        if (res.code == 1000 && res.data) {
          this.agreementName = res.data.agreementName || '';
          this.agreementDetail = res.data.agreementDetail || '';
          this.isShow = res.data.isShow || 0;
          if(this.isShow && this.agreementName){
            this.$emit('agreementName',this.agreementName)
          }
        }
      })
    },
    close() {
      this.show = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #ebecef;
  }
  img {
    margin-bottom: 10px;
    height: 40px;
  }
  .contentWrap {
    text-align:justify;
    height: 555px;
    overflow-y: scroll;

  }
}
.checkout_wrap{
    margin-top: 20px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.agreementName-show {
  /deep/ .el-dialog__header {
    display: none;
  }
}
</style>